import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService } from "src/app/shared/services/data.service";
import { ShoppingCartService } from "src/app/shared/services/shopping-cart.service";
import { Subscription } from "rxjs";
import { ProductService } from "src/app/shared/services/product.service";
import { Product } from "src/app/shared/models/product";
import { Router } from "@angular/router";
import { OrderService } from "src/app/shared/services/order.service";
import { UtilsService } from "src/app/shared/services/utils.service";

type optionsType = {
  name: string;
  value: string;
}
@Component({
  selector: "app-checkout",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.scss"],
})

export class CheckoutComponent implements OnInit {
  cart: Product[];
  totalItemsCount: number;
  totalCartPrice: number;
  totalVatCartPrice: number;
  totalPrice: number = 0;
  totalVat: number = 0;
  products: any = [];
  countries: any = [];
  states: any = [];
  lgas: any = [];
  fetchingStates: boolean = false;
  fetchingLga: boolean = false;
  deliveryFee: number = 0;
  orderDetails: any = {};
  deliveryMtd: string;
  merchant: any = {};
  countryId: number;
  stateId: number;
  lgaId: number;
  selectedState: boolean = false;
  merchantAddress: string;
  cartSubscription: Subscription;
  qtySubscription: Subscription;
  priceSubscription: Subscription;
  merchantSubscription: Subscription;
  vatTotalSubscription: Subscription;
  loading: boolean = false;
  alertMessage: string = " ";
  showLoader: boolean = false;
  showSuccessAlert: boolean = false;
  showErrorAlert: boolean = false;
  showState: boolean = false;
  showLga: boolean = false;
  merchantCurrency?: string = "";
  merchantSettlementType?: string|null ="";
  paymentOptions : optionsType[] = [];
  fetchingLeadTime: boolean = false;
  leadTime: string = "";
  constructor(
    private dataService: DataService,
    private cartService: ShoppingCartService,
    private productService: ProductService,
    private router: Router,
    private orderService: OrderService,
    private utils: UtilsService
  ) {}

  submit(f) {
    // console.log(f.valid);

    if (f.valid) {
      f = f.value;
      this.loading = true;
      this.orderDetails.customer_name = f.customerName;
      this.orderDetails.customer_phone = f.phoneNumber;
      this.orderDetails.customer_email = f.emailAddress;
      this.orderDetails.delivery_type = f.deliveryMethod;
      this.orderDetails.country_id = this.countryId;
      this.orderDetails.state_id = this.stateId;
      this.orderDetails.lga_id = this.lgaId;
      this.orderDetails.payment_mode = f.paymentMethod;
      // this.orderDetails.variation_id =

      if (f.deliveryMethod === "delivery") {
        this.orderDetails.delivery_address = f.streetAddress;
      } else {
        this.orderDetails.delivery_address = this.merchantAddress;
      }

      if (Object.entries(this.products).length === 0) {
        for (let item of this.cart) {
          let obj = (({ id, variation_id, quantity }) => ({
            id,
            variation_id,
            quantity,
          }))(item);
          this.products.push(obj);
        }
      }

      this.orderDetails.products = this.products;

      console.log(this.orderDetails);
      this.productService.createOrder(this.orderDetails).subscribe(
        (data) => {
          console.log(data);
          if (data.status === "success" && f.paymentMethod === "ONLINE") {
            this.alertMessage = `Your order is complete and an orderId have been
              generated, please wait while we redirect you to payment page`;
            this.showSuccessAlert = true;
            this.showLoader = true;
            this.clearCart();
            window.location.replace(data.data.payment_link);
          } else if (
            data.status === "success" &&
            f.paymentMethod !== "ONLINE"
          ) {
            this.router.navigate(["/order-success"], {
              queryParams: {
                paymentMethod: f.paymentMethod,
                cicodOrderId: data.data.cicod_order_id,
                email: f.emailAddress,
                amount:
                  +this.deliveryFee + +this.totalCartPrice + +this.totalVat,
                oid: data.data.id,
              },
            });
            this.clearCart();
          } else if (data.status === "error") {
            this.alertMessage = data.message;
            this.showErrorAlert = true;
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          console.log(err);
        }
      );
    }
  }

  checkToast() {
    // console.log("clicked");
    this.utils.showErrorToast(
      " We could not process your payment , Please try again"
    );
  }

  setDelivery(e: string) {
    // console.log(e);
    this.deliveryMtd = e;
    if (e === "pickUp" && this.deliveryFee) {
      this.deliveryFee = 0;
      this.totalPrice = this.totalVatCartPrice;
    }
    if (e === "pickUp") {
      // check the products that are ready to ship
      let productNotReady = this.cart
            .filter(product => !product.ready_to_ship)
            .map(product => product.production_no_of_days);
      let maxLeadTime: number = productNotReady.length ? Math.max.apply(null, productNotReady) : 0;
      // set lead time to same day if all are ready to ship otherwise get the maximum production time of the products
      this.fetchingLeadTime = false;
      this.leadTime = maxLeadTime > 0 ? `${maxLeadTime} day(s)`: 'SAME DAY';      
    }else{
      this.leadTime = "";
    }
  }

  getMerchant() {
    this.merchantSubscription = this.dataService.merchantDetails.subscribe(data =>{
       this.merchant = data;
       // console.log(this.storeName);
       console.log("merchant:",this.merchant);
     });
   }
  ngOnInit() {
    this.showSuccessAlert = false;
    this.showErrorAlert = false;
    this.cart = this.cartService.cartItems;
    this.totalCartPrice = this.cartService.totalPrice;
    this.totalVatCartPrice = this.cartService.totalPriceWithVat;
    this.totalItemsCount = this.cartService.totalItemsCount;
    this.totalVat = this.cartService.totalVat;

    this.totalPrice = this.totalVatCartPrice;

    console.log("log cart:",this.cart);




    // this.totalVat = this.cart.reduce((acc, product) => acc + (product.vatAmount * product.quantity ), 0);

    let _cart: string;
    _cart = JSON.stringify(this.cart);
    this.cart = JSON.parse(_cart);

    this.merchantSubscription = this.dataService.merchantDetails.subscribe(data =>{
      this.merchant = data;
      if(this.merchant && Object.keys(this.merchant||{}).length ){
        this.merchantCurrency = this.merchant.merchantCurrency;
        this.merchantSettlementType = this.merchant.settlementModeType;
        let online = [{name:'Online Payment', value: 'ONLINE'}]
        // let online = [{name:'Online Payment', value: 'ONLINE'}, {name: 'Pay with USSD', value: 'USSD'}]
        let offline = [ {name: 'Direct Bank Transfer', value: 'BANK'}]
        // let offline = [{name: 'Cash', value: 'CASH'}, {name: 'Direct Bank Transfer', value: 'BANK'}, {name: 'Your POS', value:'POS'}]
        let both = online.concat(offline)

        if (this.merchantSettlementType == 'OFFLINE_AND_ONLINE') {
          this.paymentOptions = both
        }
        if (this.merchantSettlementType == 'ONLINE') {
          this.paymentOptions = online
        }
        if (this.merchantSettlementType == 'OFFLINE') {
          this.paymentOptions = offline
        }

        localStorage.setItem("currency", this.merchantCurrency);
        console.log("want",this.merchantSettlementType, this.merchantCurrency);

      }
      console.log("options:",this.paymentOptions);
    });

    this.cartSubscription = this.dataService.cartItemsSubject.subscribe(
      (cartitems) => {
        this.cart = cartitems;
        // console.log("here" + this.cart);
      }
    );

    this.qtySubscription = this.dataService.cartQtySubject.subscribe(
      (quantity) => {
        this.totalItemsCount = quantity;
      }
    );

    this.priceSubscription = this.dataService.cartVatPriceSubject.subscribe(
      (totaPrice) => {
        this.totalPrice = totaPrice;
        // this.totalPrice += this.totalCartPrice ;
      }
    );

    this.vatTotalSubscription = this.dataService.vatTotalSubject.subscribe(
      (totalVat) => {
        this.totalVat = totalVat;
      }
    );
    this.getMerchantAddress();
    this.getCountries();


  }

  getMerchantAddress() {
    this.dataService.merchantConfig.subscribe((data: any) => {
      this.merchantAddress = data.merchant_region;
    });
  }

  getCountries() {
    this.orderService.getCountry().subscribe(
      (data) => {
        this.countries = data.data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getStates(id: number) {
    this.orderService.getState(id).subscribe(
      (data) => {
        this.states = data.data;
        this.fetchingStates = false;
        // console.log(this.states);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  checkLgaDeliveryStatus(stateId: number) {
    let arr = this.states.filter((st) => {
      if (st.id == stateId) {
        return st;
      }
    });
    return arr[0].has_lga;
  }

  getLga(id: number) {
    this.fetchingLeadTime = true;

    if (!this.checkLgaDeliveryStatus(id)) {
      this.getDeliveryFee(
        this.totalCartPrice + this.totalVat,
        this.countryId,
        this.stateId
      );
    }

    this.orderService.getLga(id).subscribe(
      (data) => {
        this.lgas = data.data;
        this.fetchingLga = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getDeliveryFee(
    orderAmount: number,
    countryId: number,
    stateId: number,
    lgaId?: number
  ) {
    this.orderService
      .getDeliveryRate(orderAmount, countryId, stateId, lgaId)
      .subscribe(
        (data) => {
          console.log("deliveryrate:",data);

          this.deliveryFee = data.data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getLeadTime(
    productIds: number[],
    countryId: number,
    stateId: number,
    lgaId?: number
  ) {
    this.fetchingLeadTime = true;
    this.orderService
      .retrieveLeadTime(productIds, countryId, stateId, lgaId)
      .subscribe(
        (data) => {
          console.log("leadTime:",data);
          this.leadTime = data.data.lead_time;
          this.fetchingLeadTime = false;
        },
        (err) => {
          console.log(err);
          this.fetchingLeadTime = false;
        }
      );
      this.fetchingLeadTime = false;
  }

  fetchCountryStates(countryId: number) {
    // this.showState = true ;
    this.fetchingStates = true;
    this.countryId = countryId;
    this.getStates(countryId);
  }

  fetchStateLga(stateId: number) {
    this.showLga = true;
    this.fetchingLga = true;
    this.stateId = stateId;
    this.getLga(stateId);
    let productIds = this.cart.map((item)=>item.id);  
      
    this.getLeadTime(productIds, this.countryId, stateId);

  }

  calcDelivery(lgaId: number) {
    this.lgaId = lgaId;
    this.getDeliveryFee(
      this.totalCartPrice + this.totalVat,
      this.countryId,
      this.stateId,
      lgaId
    );
    let productIds = this.cart.map((item)=>item.id);  
    this.getLeadTime(productIds, this.countryId, this.stateId, lgaId);
  }

  fetchStateCalcDelivery(stateId:number){
    this.fetchStateLga(stateId); this.calcDelivery(stateId)
  }

  removeFromCart(id) {
    this.cartService.remove(id);
  }
  clearCart() {
    this.cartService.empty();
    // this.totalCartPrice = 0;
    this.totalPrice = 0;
  }
  ngOnDestroy() {
    this.cartSubscription.unsubscribe();
    this.qtySubscription.unsubscribe();
    this.priceSubscription.unsubscribe();
  }
}
